<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props" forcePage="header">
    <component :is="HorizontalNavigation" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>

</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import HorizontalNavigation from './HorizontalNavigation.vue';
import type { HorizontalNavigationProps } from './HorizontalNavigation.ts';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-horizontal-navigation';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<HorizontalNavigationProps>();
const changableProps = useChangableProps(componentName, props);

</script>


